export type ContentBlock =
  | "toggle-row"
  | "video"
  | "image-grid"
  | "phone"
  | "hero-image"
  | "card"
  | "pillbox";

export type SidebarBlock = "timeline-item";

export interface StepSkeletonConfig {
  blocks: ContentBlock[];
  sidebar?: SidebarBlock[];
  hideBack?: boolean;
}

export const STEP_SKELETONS: Record<string, StepSkeletonConfig> = {
  // Chargebacks onboarding
  "cb-overview": { blocks: ["image-grid"], hideBack: true },
  "cb-how-it-works": { blocks: ["card", "card", "card"] },
  "cb-permissions": { blocks: ["card"] },
  "cb-dispute-sources": { blocks: ["card", "card", "card", "card", "card"] },
  "cb-go-live": { blocks: ["hero-image"] },
  "cb-completion": { blocks: ["hero-image"], hideBack: true },

  // Shipping & Fulfillment onboarding
  "sf-overview": { blocks: ["image-grid"], hideBack: true },
  "sf-current-software": { blocks: ["video"] },
  "sf-channels": { blocks: ["toggle-row", "toggle-row", "toggle-row"] },
  "sf-carriers": { blocks: ["toggle-row", "toggle-row", "toggle-row"] },
  "sf-packaging": { blocks: ["card", "card", "card"] },
  "sf-packing-slip": { blocks: ["card", "card", "card"] },
  "sf-shipping-automations": { blocks: ["hero-image"] },
  "sf-order-automations": { blocks: ["toggle-row", "toggle-row"] },
  "sf-international": { blocks: ["card", "card"] },
  "sf-views": { blocks: ["hero-image"] },
  "sf-billing": { blocks: ["card", "card"] },
  "sf-pain-points": { blocks: ["hero-image"] },
  "sf-completion": { blocks: ["hero-image"], hideBack: true },

  "oe-overview": { blocks: ["image-grid"], hideBack: true },
  "oe-how-it-works": {
    blocks: ["video"],
    sidebar: [
      "timeline-item",
      "timeline-item",
      "timeline-item",
      "timeline-item",
      "timeline-item",
    ],
  },
  "oe-customer-actions": {
    blocks: ["toggle-row", "toggle-row", "toggle-row", "toggle-row"],
  },
  "oe-timing": { blocks: ["card", "card"] },
  "oe-platforms": { blocks: ["toggle-row", "toggle-row", "toggle-row"] },
  "oe-widget-preview": { blocks: ["phone"] },
  "oe-activate": { blocks: ["video", "pillbox"] },
  "oe-completion": { blocks: ["hero-image"], hideBack: true },
  "schedule-call": { blocks: ["hero-image"] },

  // Returns onboarding
  "ret-return-policy": { blocks: ["card", "card"] },
  "ret-processing-rules": {
    blocks: ["toggle-row", "toggle-row", "toggle-row"],
  },
  "ret-portal-preview": { blocks: ["phone"] },
  "ret-about-coverage": { blocks: ["video"] },
  "ret-coverage-widget": { blocks: ["video", "pillbox"] },
  "ret-app-embed": { blocks: ["video", "pillbox"] },
  "ret-communications": { blocks: ["toggle-row", "toggle-row", "toggle-row"] },
  "ret-billing": { blocks: ["card", "card"] },
  "ret-go-live": {
    blocks: [
      "toggle-row",
      "toggle-row",
      "toggle-row",
      "toggle-row",
      "toggle-row",
      "card",
    ],
  },
  "ret-schedule-call": { blocks: ["hero-image"], hideBack: true },
};
